$(function(){
	if( $('.thinq-section').length == 0 ) return;
	var $thinq = $('.thinq-section');

	/*
	 * Common Interaction
	 */
	function objInteraction(){
		var $obj = $('.animate-target');
		$obj.each(function() {
			if( !$(this).hasClass('animated') ) {
				var t = $(this).offset().top;
				var b = $(this).offset().top + $(this).outerHeight();
				if(isInScreen(t, b)) {
					var delayTimer = parseInt($(this).attr('data-delay'));
					$(this).delay(delayTimer).queue(function(){$(this).addClass('animated')});
				}
			}
		});
	}

	/*
	 * Keyvisual Slide
	 */

	function keyvisualSlide() {
		var $heroArea = $thinq.find('.hero-area');
		var $heroSlider = $heroArea.find('.list');
		var $dotsContainer = $heroArea.find('.dots-container');

		$heroSlider.slick({
			dots: true,
			infinite: false,
			arrows: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 8000,
			appendDots: $dotsContainer
		});
		$dotsContainer.append('<button class="btn-pause"><span class="sr-only">pause</span></button>');

		var $pauseBtn = $heroArea.find('.btn-pause');
		$pauseBtn.on('click',function(){
			if ( $pauseBtn.hasClass('play') ) {
				$(this).removeClass('play').children('span').text('pause');
				$heroSlider.slick('slickPlay');
			} else {
				$(this).addClass('play').children('span').text('play');
				$heroSlider.slick('slickPause');
			}
		});

		// 초기 세팅
		if($(this).find('.item').eq(0).hasClass('t-white')){
			$heroSlider.find('.slick-arrow').removeClass('dark');
		} else {
			$heroSlider.find('.slick-arrow').addClass('dark');
		}

		// 슬라이드 이미지 종류에 따른 버튼 컬러 변경
		var currentSlide = $heroSlider.slick('slickCurrentSlide');
		$heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			if($(this).find('.item').eq(nextSlide).hasClass('t-white')){
				$heroSlider.find('.slick-arrow').removeClass('dark');
			} else {
				if(window.innerWidth < 768 && $(this).find('.item').eq(nextSlide).hasClass('hero-pcc-promotion')) {
					// hero-pcc-promotion 예외처리
					$heroSlider.find('.slick-arrow').removeClass('dark');
				} else {
					$heroSlider.find('.slick-arrow').addClass('dark');
				}
			}
		});
	}

	/*
	 * Scroll Animation
	 */
	function scrollAnimation(){
		var isScroll = 0;
		var scrollAniHeight;

		var scrollAniInterval = false;
		function scrollAniResize(){
			if(scrollAniInterval) clearTimeout(scrollAniInterval);
			scrollAniInterval = setTimeout(function() {
				if(window.innerWidth >= 768) {
					//scrollAniHeight = window.innerHeight;

					if(window.innerHeight >= 1087){
						scrollAniHeight = 1087;
					} else if (window.innerHeight <= 740) {
						scrollAniHeight = 740;
					} else {
						scrollAniHeight = window.innerHeight;
					}
				} else {
					scrollAniHeight = 509;
				}
			}, 100);
		}
		$(window).on('resize.scrollAniResize', scrollAniResize).trigger('resize.scrollAniResize');

		$('.hero-area').on('mousewheel', function (e) {
			//$('body').addClass('is-scrolling');
			if (isScroll == 1) return false;
			e.preventDefault();
			var evt = window.event || e;
			// var delta = evt.detail ? evt.detail : evt.wheelDelta;
			// if (isBrowserCheck()=='Firefox') delta = -evt.originalEvent.detail;
			var delta = evt.wheelDelta;

			if (delta < 0) {
				isScroll = 1;
				scrollDown();
			} else {
				isScroll = 1;
				scrollUp();
			}
		});
		//if ($('body').hasClass('is-scrolling') == true) {
			// $('.benefit-area').on('mousewheel', function (e) {
			// 	e.preventDefault();
			// });
		//}

		function scrollDown(){
			$('html,body').stop().animate({scrollTop: scrollAniHeight}, 500, function () {
				isScroll = 0;
				//$('body').removeClass('is-scrolling');
				//$('.benefit-area').off('mousewheel');
			});
		}
		function scrollUp(){
			$('html,body').stop().animate({scrollTop: 0}, 500, function () {
				isScroll = 0;
				//$('body').removeClass('is-scrolling');
			});
		}
	}
	$(window).on('load', function(){
		if (isBrowserCheck()=='Chrome'){
			scrollAnimation();
		}
	});

	/*
	 * Sticky Menu
	 */
	 function stickyMenu() {
 		var $stickyArea = $thinq.find('.sticky-menu');
 		var $stickyLink = $stickyArea.find('.menu-list');
		var $stickyInner = $stickyArea.find('.sticky-inner');
 		var stickyHeight;
 		var stickyUpperHeight;
 		var activeLineWidth;

 		function stickyResizeSet(){
 			stickyHeight = $stickyArea.height();
 			var naviHeight = $('.navigation').height();
 			var breadcrumbHeight = $('.breadcrumb').height();
 			var heroHeight = $('.hero-area').height();


 			if(window.innerWidth >= 768) {
 				$('body').removeClass('isMobile');
 				stickyUpperHeight = naviHeight + breadcrumbHeight + heroHeight;
 			} else {
 				$('body').addClass('isMobile');
 				stickyUpperHeight = naviHeight + heroHeight;

 			}
 			// sticky fixed reset
 			if( $(window).scrollTop() >= stickyUpperHeight ){
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

 		function stickyScrollSet(){
 			var windowTop = $(window).scrollTop();
 			if(windowTop >= stickyUpperHeight){
 				// sticky fixed
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

		// Product Tab Scroll Design
		function mScrollCheck(){
			if( $('body').hasClass('no-touch') ){
				$stickyInner.find('.menu-list').mCustomScrollbar({
					theme:'dark',
					mouseWheelPixels:300,
					axis:'x'
				});
			} else {
				$stickyInner.append('<div class="arrow"></div>');
				// $stickyInner.on('touchend', function(){
				// 	$stickyInner.find('.arrow').addClass('js-fade');
				// });
			}
		}

		mScrollCheck();
		setTimeout(function(){
			$stickyInner.find('.arrow').addClass('js-fade');
		},3000);
 		$(window).on('resize.stickyResizeSet', stickyResizeSet).trigger('resize.stickyResizeSet');
 		$(window).on('scroll.stickyScrollSet', stickyScrollSet).trigger('scroll.stickyScrollSet');

 	}
	/*
	 * Benefit Area
	 */
	 function benefitArea(){
		 var $benefitArea = $thinq.find('.benefit-area');
		 var $benefitSlide = $benefitArea.find('.benefit-slide .list');
		 var $benefitVideoLayer = $benefitArea.find('.benefit-video-layer');
		 $benefitSlide.slick({
			 dots:true,
			 infinite:false,
			 arrows:true,
			 autoplay:false
		 });
		 function benefitVideoPlay(e){
	 			e.preventDefault();

	 			var $self = $(this);
	 			var targetSrc = $self.attr('data-src');
	 			var targetId = $self.attr('href');

	 			useScrollSmooth = false;
	 			$('body').addClass('body-scroll-hidden-fix');

	 			$benefitVideoLayer.show().stop().animate({'opacity':'1'}, 500);
	 			$(targetId).addClass('active');

	 			setTimeout(function(){
	 				$(targetId).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
	 				$(targetId).find('.btn-close').focus();
	 				focusTrapSet(targetId);
	 			}, 300);
	 		}

			function benefitVideoClose(e){
				e.preventDefault();

				var $targetVideo = $(this).closest('.video-detail');
				var targetId = $targetVideo.attr('id');

				useScrollSmooth = true;
				$('body').removeClass('body-scroll-hidden-fix');

				$('#'+ targetId).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
				$('#'+ targetId).removeClass('active');
				$benefitVideoLayer.animate({'opacity':'0'}, 500, function(){
					$(this).hide();
				});
			}

			$benefitSlide.find('.btn-play').on('click', benefitVideoPlay);
			//$benefitListMobile.find('.play').on('click', benefitVideoPlay);
			$benefitVideoLayer.find('.btn-close').on('click', benefitVideoClose);
	 }
	/*
	 * Product Area
	 */
	 function productArea(){
		 var $productArea = $thinq.find('.product-area .product-wrap-pc');
		 var $infoList = $productArea.find('.info-list');
		 var $infoItem = $productArea.find('.info-item');
		 var $hashList = $productArea.find('.hash-list');
		 var $productList = $productArea.find('.product-list .inner');
		 $infoItem.attr('tabindex', '0' );
		 $productList.find('a').attr('tabindex','-1');
		 $productList.find('.on').children().removeAttr('tabindex');
		 $hashList.find('a').on('click',function(e){
			 e.preventDefault();
			 var _index = $(this).parent('li').index();
			 $(this).parent().addClass('on').siblings().removeClass('on');
			 $(this).parents('.hash-area').children('.hash-desc').children().eq(_index).addClass('on').siblings().removeClass('on');
		 })
		 $productList.find('a').on('click',function(e){
		 	 e.preventDefault();
			 var targetId = $(this).attr("href");
			 var openProduct = $infoList.find(targetId);
			 $(this).parent().addClass('on').siblings().removeClass('on');
			 $infoItem.removeClass('on');
			 openProduct.addClass('on');
			 $productList.find('a').attr('aria-selected', 'false');
  		 $(this).attr('aria-selected', 'true');
 			 $(this).removeAttr('tabindex');
 			 $(this).parent().siblings().children('a').attr('tabindex', '-1' );
		 })
		 $productList.slick({
				slide: 'div',
				infinite : false,
				slidesToShow : 4,
				slidesToScroll : 4,
				speed : 300,
				arrows : true,
				dots : true,
				autoplay : false,
				//
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow:3,
							slidesToScroll : 3,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow:2,
							slidesToScroll : 2,
						}
					}
				]
		 });

		 // mobile
		 var $mobileProductArea = $thinq.find('.product-area .product-wrap-mobile');
		 var $mobileProductList = $mobileProductArea.find('.product-list .inner');
		 var $mobileInfoList = $mobileProductArea.find('.info-list');
		 var $mobileInfoItem = $mobileProductArea.find('.info-item');

		 // $mobileProductList.slick({
			// 	dots:false,
			// 	arrows:true,
			// 	slidesToShow : 1,
			// 	slidesToScroll : 1,
			// 	variableWidth: true,
			// 	infinite : false,
			// 	draggable: true,
			// 	swipe: true,
			// 	touchMove: true,
			// 	focusOnSelect: true,
			// 	centerMode: false,
			// 	outerEdgeLimit: true,
		 // });


		 $mobileProductList.find('a').on('click',function(e){
		 	 e.preventDefault();
			 var targetId = $(this).attr("href");
			 var openProduct = $mobileInfoList.find(targetId);
			 var openProductHeight = openProduct.height();
			 //$(this).parent().addClass('active').siblings().removeClass('active');
			 //$mobileInfoItem.removeClass('active');
			 //openProduct.addClass('active');
			 openProduct.find('.hash-list').slick('slickGoTo', 0);
			 $mobileInfoList.parent().css("height",openProductHeight);
			 //$mobileProductList.find('a').attr('aria-selected', 'false');
  		 //$(this).attr('aria-selected', 'true');
		 });

		 $mobileProductArea.find('.hash-list').each(function(){
			 if( $(this).children().length > 1 ) {
				 var $dotsContainer = $(this).parent().find('.dots-container');
				 $(this).slick({
					 dots:true,
					 arrows:false,
					 appendDots: $dotsContainer,
					 autoplay:true,
					 speed: 800,
					 fade:true
				 });
				 $dotsContainer.append('<button class="btn-pause"><span class="sr-only">pause</span></button>');
			 }

			 var $pauseBtn = $(this).parent().find('.btn-pause');
			 $pauseBtn.on('click',function(){
				 if ( $pauseBtn.hasClass('play') ) {
					 $(this).removeClass('play').children('span').text('pause');
					 $(this).parent().prev('.hash-list').slick('slickPlay');
				 } else {
					 $(this).addClass('play').children('span').text('play');
					 $(this).parent().prev('.hash-list').slick('slickPause');
				 }
			 });
		 });
		 var activeH = $mobileProductArea.find('.info-item.active');
			$mobileProductArea.find('.info-area').height( activeH.height() );
			$(window).on('resize',function(){
				$mobileProductArea.find('.info-area').height( activeH.height() );
			});
	 }
	/*
	 * Experience Area
	 */
	function appArea(){
		var $appArea = $thinq.find('.app-area');
		var $appInfo = $appArea.find('.app-info');
		var $appInfoSlide = $appArea.find('.info-slide');
		// var $endorsement = $appArea.find('.endorsement');
		// var $endorsementSlide = $appArea.find('.endorsement-slide');

		$appInfoSlide.slick({
			dots: false,
			infinite: false, //slick plugin 수정 후 false로 변경
			arrows: false,
			prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
			nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
						dots: true
					}
				}
			]
		});
		$appInfoSlide.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$appInfo.find('.list button').attr('aria-selected', 'false');
			$appInfo.find('.list li').removeClass('active').eq(nextSlide).addClass('active').find('button').attr('aria-selected', 'true');
		});
		$appInfo.find('.list button').on('click',function(e){
			e.preventDefault();

			var $self = $(this);
			var $target = $self.parent('li');
			var idx = $target.index();

			$appInfo.find('.list li').removeClass('active');
			$target.addClass('active');

			$appInfo.find('.list button').attr('aria-selected', 'false');
			$self.attr('aria-selected', 'true');

			$appInfoSlide.slick('slickGoTo', idx);
		});

	}

	/*
	 * Magazine Area
	 */
	function magazineArea(){
		var $magazineArea = $thinq.find('.magazine-area');
		var $default = $magazineArea.find('.default');
		var $defaultSlide = $default.find('.list');
		var $thumbnailSlide = $magazineArea.find('.thumbnail-slide');
		var $mediaList = $magazineArea.find('.media-list');
		var $mediaSlide = $mediaList.find('.article');
		var $magazineVideoLayer = $thinq.find('.common-video-layer');

		$defaultSlide.slick({
			dots: false,
			infinite: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			draggable:false,
			swipe: false,
			touchMove:false
		});
		$thumbnailSlide.slick({
			dots: false,
			infinite: false,
			arrows: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
			nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>',
			responsive: [
				// {
				// 	breakpoint: 992,
				// 	settings: {
				// 		slidesToShow: 5,
				// 		slidesToScroll: 1
				// 	}
				// },
				{
					breakpoint: 861,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						dots: false,
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}
			]
		});

		$defaultSlide.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			// $thumbnailSlide.find('.item a').removeClass('active');
			// $thumbnailSlide.find('.item').eq(nextSlide).find('a').addClass('active');

			// if(nextSlide == 2){
			// 	$thumbnailSlide.slick('slickGoTo', 0);
			// } else if (nextSlide == 3){
			// 	$thumbnailSlide.slick('slickGoTo', 3);
			// }
		});

		$thumbnailSlide.find('a').on('click', function(e){
			e.preventDefault();

			var $self = $(this);
			var $current = $self.closest('.thumbnail').find('.active');
			var idx = $self.closest('.item').index();

			$current.removeClass('active');
			$self.addClass('active');

			if($defaultSlide.hasClass('slick-initialized')){
				$defaultSlide.slick('slickGoTo', idx);

				$defaultSlide.find('.video-js').find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').attr('tabindex','-1');
				$defaultSlide.find('.btn-close').attr('tabindex','-1');
			}

			$default.find('.video-layer .btn-close').trigger('click');
			// if(!$('body').hasClass('isMobile') && $default.find('.play').hasClass('enabled') ){

			// }
		});
		$thumbnailSlide.find('.item:eq(0) a').trigger("click");

		function magazineVideoPlaActive(ta){
			ta.find('.video-js').find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').attr('tabindex','0');
			ta.find('.btn-close').attr('tabindex','0');

			setTimeout(function(){
				ta.find('.video-layer').find('.vjs-big-play-button').trigger('click');
				ta.find('.video-layer').addClass('active');
				focusTrap( ta.find('.video-layer') );
			}, 300);
		}
		function magazineVideoPlay(e){
			e.preventDefault();

			if(!$('body').hasClass('isMobile')){
				var $target = $(this).closest('.item');
				//$(this).addClass('enabled');
				if($target.find('video').length > 0){
					magazineVideoPlaActive($target);
					/*$target.find('.video-js').find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').attr('tabindex','0');
					$target.find('.btn-close').attr('tabindex','0');
					setTimeout(function(){
						$target.find('.video-layer').find('.vjs-big-play-button').trigger('click');
						$target.find('.video-layer').addClass('active');
						focusTrap( $target.find('.video-layer') );
					}, 200);*/
				}else{
					var $targetVideo = $target.find('.video');
					var _tagId = $targetVideo.data('id');
					var _videoId = $targetVideo.data('videoId');
					var _videoAccount = $targetVideo.data('account');
					var src = '//players.brightcove.net/'+_videoAccount+'/default_default/index.min.js';
					if( $(this).parent().find(".video-layer .video").hasClass("youtube-player") ){
						 var _youtubeVideo = $(this).parent().find(".video-layer .youtube-player");
						 var _tagYoutubeId = _youtubeVideo.data("videoId");
							setTimeout(function(){
							$(document).ready(function(){
								magazineVideoPlaActive($target);
							})
			 				$('#'+ _tagYoutubeId)[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
							_youtubeVideo.next('.btn-close').attr('tabindex','0').focus();
			 			//	focusTrapSet(this);
			 			}, 300);
						//$('#'+ targetId).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
					} else {
						$targetVideo.empty();
						$targetVideo.append('<video id="'+_tagId+'" data-video-id="'+_videoId+'" data-account="'+_videoAccount+'" data-player="default" data-embed="default" class="video-js" playsinline controls></video>');
						$('script[src="'+src+'"]').remove();
						$('body').append('<sc'+'ript src="'+src+'"></scr'+'ipt>');
						$(document).ready(function(){
							magazineVideoPlaActive($target);
						})
					}
				}
			} else {
				var targetId = $(this).attr('href');
				var $targetVideo = $magazineVideoLayer.find(targetId).find('.video');
				var _videoId = $targetVideo.data('videoId');
				var _videoAccount = $targetVideo.data('account');
				var src = '//players.brightcove.net/'+_videoAccount+'/default_default/index.min.js';

				useScrollSmooth = false;
				$('body').addClass('body-scroll-hidden-fix');
				$magazineVideoLayer.show().stop().animate({'opacity':'1'}, 500);
				$magazineVideoLayer.find(targetId).show();
				if( $(this).parent().find(".video-layer .video").hasClass("youtube-player") ){
					 //var _youtubeVideo = $(this).parent().find(".video-layer .youtube-player");
					 var _tagYoutubeId = $targetVideo.data("videoId");
						setTimeout(function(){
						$(document).ready(function(){
							//magazineVideoPlaActive($target);
							magazineVideoPlaActive($magazineVideoLayer.find(targetId));
						})
						$targetVideo.find("iframe")[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
						$targetVideo.find('.btn-close').attr('tabindex','0').focus();
					  focusTrapSet($targetVideo);
					}, 300);
				} else {
					$targetVideo.empty();
					$magazineVideoLayer.find(targetId).find('.vjs-big-play-button').trigger('click');
					$targetVideo.append('<video id="'+_tagId+'" data-video-id="'+_videoId+'" data-account="'+_videoAccount+'" data-player="default" data-embed="default" class="video-js" playsinline controls></video>');
					$('script[src="'+src+'"]').remove();
					$('body').append('<sc'+'ript src="'+src+'"></scr'+'ipt>');
					$(document).ready(function(){
						magazineVideoPlaActive($magazineVideoLayer.find(targetId));
					})
					focusTrap(targetId);
				}
			}
		}
		function magazineVideoClose(e){
			e.preventDefault();

				var $target = $(this).closest('.video-layer');

			//var targetId = $target.siblings('.play').attr('href');
			//$target.siblings('.play').removeClass('enabled');

			//setTimeout()
			if( $(this).parent().find(".youtube-player").length > 0) {
				$(this).parent().find(".youtube-player").find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
				$(this).find('.btn-close').attr('tabindex','-1');
				setTimeout(function(){
					$target.removeClass('active');
				}, 200);
			} else {
				if($target.find('video').length < 1) return false;
				$target.find('video')[0].pause();
				$target.find('.video-js').find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').attr('tabindex','-1');
				$target.find('.btn-close').attr('tabindex','-1');

				setTimeout(function(){
					$target.removeClass('active');

					//$default.find('a[href="'+targetId+'"]').focus();
					//$(this).closest('.item').find('.play').focus();
				}, 200);
			}


		}
		function magazineVideoMobileClose(e){
			e.preventDefault();

			var $targetVideo = $(this).closest('.video-detail');
			var targetId = $targetVideo.attr('id');

			useScrollSmooth = true;
			$('body').removeClass('body-scroll-hidden-fix');

			if( $(this).parent().find(".youtube-player").length > 0) {
				$(this).parent().find(".youtube-player").find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
				$(this).find('.btn-close').attr('tabindex','-1');
				$targetVideo.hide();
				$magazineVideoLayer.stop().animate({'opacity':'0'}, 500, function(){
					$(this).hide();
				});
				$default.find('a[href="#'+targetId+'"]').focus();
			} else {
				$targetVideo.find('video')[0].pause();
				$targetVideo.hide();
				$magazineVideoLayer.stop().animate({'opacity':'0'}, 500, function(){
					$(this).hide();
				});

				$default.find('a[href="#'+targetId+'"]').focus();
			}


		}

		$default.find('.video-block .play').on('click', magazineVideoPlay);
		$default.find('.video-layer .btn-close').on('click', magazineVideoClose);
		$magazineVideoLayer.find('.btn-close').on('click', magazineVideoMobileClose);

		// vjs accessibility issue 191227
		// $(document).ready(function(){
		// 	$(".vjs-menu-content").each(function(){
		// 		var cL = $(this).children().length;
		// 		if( cL == 0) {
		// 			$(this).remove();
		// 		}
		// 		else if( cL == 1) {
		// 			//(this).children().attr("role", "menuitem");
		// 			$(this).addClass('aaaaaaaa');
		// 	  }
		// 	});
		// })

		var mediaSlideInterval = false;
		function mediaSlideResize(){
			if(mediaSlideInterval) clearTimeout(mediaSlideInterval);
			mediaSlideInterval = setTimeout(function() {
				if( window.innerWidth <= 991 ){
					if (!$mediaSlide.hasClass('slick-initialized')){
						$mediaSlide.slick({
							// autoplay:true,
							// autoplaySpeed:5000,
							dots: true,
							infinite: false,
							arrows: true,
							listStyle: true,
							prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
							nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>'
							//appendDots:$mediaList.find('.indicator-area')
						});
						// $mediaList.find('.slide-play').on('click',function(){
						// 	var $self = $(this);
						// 	if ($self.hasClass('is-pause')){
						// 		$self.removeClass('is-pause').addClass('is-play');
						// 		$self.text($self.attr('data-title-play'));
						// 		$mediaSlide.slick('slickPause');
						// 	} else {
						// 		$self.removeClass('is-play').addClass('is-pause');
						// 		$self.text($self.attr('data-title-stop'));
						// 		$mediaSlide.slick('slickPlay');
						// 	}
						// });
					}

				} else {
					if ($mediaSlide.hasClass('slick-initialized')){
						$mediaSlide.slick('unslick');
						$mediaSlide.removeAttr('tabindex');
						$mediaSlide.find('.item, a').removeAttr('tabindex');
					}
				}
			}, 100);
		}
		$(window).on('resize.mediaSlideResize', mediaSlideResize).trigger('resize.mediaSlideResize');
	}
	/*
	 * FAQ Area
	 */
	function faqArea(){
		var $faqArea = $thinq.find('.faq-area');
		var $faqList = $faqArea.find('.faq-list');
		var $faqLayer = $faqArea.find('.faq-layer');

		function isIE() {
			ua = navigator.userAgent;
			var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
			return is_ie;
		}
		if (isIE()){
			$faqLayer.find('.question').addClass('simple');
		}

		function faqLayerOpen(e){
			e.preventDefault();
			var targetId = $(this).attr('href');

			useScrollSmooth = false;
			$('body').addClass('body-scroll-hidden-fix');

			$('body').append('<div class="common-layer-dim"></div>');
			setTimeout(function(){
				$('.common-layer-dim').addClass('active');
				$(targetId).addClass('active');
				focusTrap(targetId);
			}, 100);
		}
		function faqLayerClose(e){
			e.preventDefault();

			var $targetLayer = $(this).closest('.faq-layer');
			var targetId = $targetLayer.attr('id');

			useScrollSmooth = true;
			$('body').removeClass('body-scroll-hidden-fix');

			$('#'+ targetId).removeClass('active');
			$('.common-layer-dim').removeClass('active');
			setTimeout(function(){
				$('.common-layer-dim').remove();
				//$faqList.find('a[href="#'+targetId+'"]').focus();
			}, 400);
		}

		$faqList.find('a').click(faqLayerOpen);
		$faqLayer.find('.btn-close').click(faqLayerClose);
	}


	keyvisualSlide();
	stickyMenu();
	benefitArea();
	productArea();
	appArea();
	magazineArea();
	faqArea();

	$(window).on('scroll.objInteraction', objInteraction).trigger('scroll.objInteraction');
});
